/* eslint-disable camelcase */
import {
  FRAGEMENT_META,
  FRAGEMENT_POST,
  FRAGEMENT_POST_CATEGORIES,
  FRAGMENT_JOB,
  FRAGMENT_POST_PAGINATION,
  FRAGMENT_OUTLET,
} from "./fragment"

export const Q_PAGE_BY_SLUG = `
  query Page($slug: String!) {
    page(slug: $slug) {
       ${FRAGEMENT_POST}
       categories {
        ${FRAGEMENT_POST_CATEGORIES}
      }
        meta {
         ${FRAGEMENT_META}
        }
    }
  }
`
export const Q_POST_BY_SLUG = `
  query Post($slug: String!) {
    post(slug: $slug) {
       ${FRAGEMENT_POST}
       categories {
        ${FRAGEMENT_POST_CATEGORIES}
      }
        meta {
         ${FRAGEMENT_META}
        }
    }
  }
`
export const Q_PAGE_REPORT = `
query PageReport($slug: String!) {
  post(slug: $slug) {
    id
    title_id
    title_en
    content_en
    content_id
    slug
    template
    page_report_category_id
    page_report_show_filter
    page_report_executive_category_id
  }
}
`

export const Q_NEAREST_OUTLET = `
  query GetNearOutlets($lat: Float!, $lng: Float!, $cinemaId: Int, $concessionId: Int, $fbConcessionId: Int) {
  cityByNearest(lat: $lat, lng: $lng, cinema_id: $cinemaId, concession_id: $concessionId, fb_concession_id: $fbConcessionId) {
    id
    name
    lng
    lat
    created_at
    updated_at
  }
}
`

export const Q_NEAREST_CONCESSION = `
  query getNearestConcession($concession_id: Int!, $city_id: Int, $lng: Float, $lat: Float) {
    concessionLocationByNearest(
      concession_id:$concession_id,
      city_id:$city_id,
      first:1,
      lng:$lng,
      lat:$lat,
    ) {
      data {
        id
        title_id
        title_en
        featured_image
        thumb_image
        meta {
          id
          key
          value
          section
          type
        }
      }
    }
  }
`

export const Q_SEARCH_OUTLET_BY_CITY_ID = `
query SEARCH_OUTLET(
  $id: Int!, 
  $concessionId: Int, 
  $cinemaId: Int, 
  $lat: Float, 
  $lng: Float
) {
  outlets(
    city_id: $id
    first: 3
    cinemaId: $cinemaId
    concessionId: $concessionId
    orderBy: [{ column: "distance", order: ASC }]
    lat: $lat
    lng: $lng
  ) {
    data {
     ${FRAGMENT_OUTLET}
    }
  }
}
`

export const Q_CITY_LIST = `
query CITYLIST ($cinema_id: Int, $concession_id: Int) {
  cities (orderBy: [{ column: "name", order: ASC }], cinema_id: $cinema_id, concession_id: $concession_id) {
    id
    name
    lng
    lat
    created_at
    updated_at
  }
}
`

export const Q_POST_CATEGORIES_BY_TYPE = `
  query PostCategories($type: PostCategoryType!) {
    postCategories(type: $type, orderBy: [ {column: "order", order: ASC} ]) {
      ${FRAGEMENT_POST_CATEGORIES}
      meta {
        ${FRAGEMENT_META}
       }
       posts {
        ${FRAGEMENT_POST}
       }
    }
  }
`
export const Q_POST_CATEGORY_BY_SLUG = `
  query PostCategory($slug: String!) {
    postCategory(slug: $slug) {
      ${FRAGEMENT_POST_CATEGORIES}
      meta {
        ${FRAGEMENT_META}
       }
       posts {
        ${FRAGEMENT_POST}
       }
    }
  }
`
export const Q_POST_CATEGORIES_BY_SLUG = `
  query PostCategories($slug: String!) {
    postCategories(slug: $slug) {
      ${FRAGEMENT_POST_CATEGORIES}
      meta {
        ${FRAGEMENT_META}
       }
       posts {
        ${FRAGEMENT_POST}
       }
    }
  }
`

export const Q_POSTS_BY_TYPE = `
query GetPostsByType ($type: PostType!, $first: Int!, $orderBy: [OrderByClause!], $page: Int, $year: Int, $categoryId: Int, $parentId: Int, $reportYear: Int) {
  posts(first: $first, type: $type, orderBy: $orderBy, page: $page, year: $year, categoryId: $categoryId, parentId: $parentId, reportYear: $reportYear) {
    data {
      ${FRAGEMENT_POST}
      categories {
        ${FRAGEMENT_POST_CATEGORIES}
      }
      meta {
        ${FRAGEMENT_META}
      }
    }
    paginatorInfo {
      ${FRAGMENT_POST_PAGINATION}
    }
  }
}
`
export const Q_JOBS_LIST = `
query getJobs($first: Int!, $orderBy: [OrderByClause!], $page: Int, $type: JobType, $location_id: Int, $position: String ) {
  jobs(first: $first, type: $type, orderBy: $orderBy, page: $page, location_id: $location_id, position: $position) {
    data {
     ${FRAGMENT_JOB}
    }
    paginatorInfo {
      ${FRAGMENT_POST_PAGINATION}
    }
  }
}`
export const Q_JOBS_DETAIL = `
query getJob($slug: String!) {
  job (slug: $slug) {
    ${FRAGMENT_JOB}
  }
}
`

export const Q_JOB_LOCATIONS = `
query location {
  jobLocations {
    id
    name
  }
}
`

export const Q_OUTLET_DETAIL = `
  query OUTLET($slug: String) {
  outlet(slug: $slug) {
    ${FRAGMENT_OUTLET}
    meta {
      ${FRAGEMENT_META}
    }
  }
  options(namespace: "now_playing") {
    option_name
    option_value
  }
}
`
export const Q_OUTLET_LIST = `
query outlets ($first: Int!, $page: Int, $city_id: Int, $concessionId: Int, $orderBy: [OrderByClause!]) {
  outlets (first: $first, page: $page, city_id: $city_id, concessionId: $concessionId, orderBy: $orderBy) {
    data {
      ${FRAGMENT_OUTLET}
    }
    paginatorInfo {
      ${FRAGMENT_POST_PAGINATION}
    }
  }
}
`
export const Q_SEARCH_OUTLET = `
query outlets ($first: Int!, $page: Int, $location: String, $city_id: Int) {
  searchOutlets (first: $first, page: $page, location: $location, city_id: $city_id) {
    data {
      ${FRAGMENT_OUTLET}
    }
    paginatorInfo {
      ${FRAGMENT_POST_PAGINATION}
    }
  }
}
`

export const Q_POST_YEAR_LIST = `
query years ($post_type: PostType!, $categoryId: Int) {
  postYearList (post_type: $post_type, category_id: $categoryId)
}
`

export const Q_FOOTER_DATA = `
query options {
  options(namespace: "general") {
    option_name
    option_value
  }
}
`

export const Q_HOME_PAGE = `
query HomePage {
  data: post(slug: "home") {
     ${FRAGEMENT_POST}
     categories {
      ${FRAGEMENT_POST_CATEGORIES}
    }
      meta {
        ${FRAGEMENT_META}
      }
  }
  product: postCategories(type: CINEMA) {
    ${FRAGEMENT_POST_CATEGORIES}
    meta {
      ${FRAGEMENT_META}
     }
     posts {
      ${FRAGEMENT_POST}
     }
  }
  news: posts(first: 3, type: NEWS, orderBy: [ {column: "published_at", order: DESC} ]) {
    data {
      ${FRAGEMENT_POST}
      categories {
        ${FRAGEMENT_POST_CATEGORIES}
      }
      meta {
        ${FRAGEMENT_META}
      }
    }
    paginatorInfo {
      ${FRAGMENT_POST_PAGINATION}
    }
  }
  stocks: stockLastPrice {
    currentPrice
    change
    changePercent
    date
    fetchDate
  }
}
`

export const Q_ABOUT_PAGE = `
query AboutPage($slug: String!, $year: Int) {
  data: post(slug: $slug) {
     ${FRAGEMENT_POST}
     categories {
      ${FRAGEMENT_POST_CATEGORIES}
    }
      meta {
       ${FRAGEMENT_META}
      }
  }
  executives: posts(first: 100, type: EXECUTIVE, page: 1) {
    data {
      ${FRAGEMENT_POST}
      categories {
        ${FRAGEMENT_POST_CATEGORIES}
      }
      meta {
        ${FRAGEMENT_META}
      }
    }
    paginatorInfo {
      ${FRAGMENT_POST_PAGINATION}
    }
  }
  awards: posts(first: 100, type: AWARD, page: 1, year: $year) {
    data {
      ${FRAGEMENT_POST}
      categories {
        ${FRAGEMENT_POST_CATEGORIES}
      }
      meta {
        ${FRAGEMENT_META}
      }
    }
    paginatorInfo {
      ${FRAGMENT_POST_PAGINATION}
    }
  }
}
`

export const Q_OUR_COMMITMENT_DETAIL = `
query ourCommitmentDetail($slug: String!, $type: PostType, $orderBy: [OrderByClause!]) {
  data: post(slug: $slug) {
     ${FRAGEMENT_POST}
     categories {
      ${FRAGEMENT_POST_CATEGORIES}
    }
      meta {
       ${FRAGEMENT_META}
      }
  }
  dataPost: posts(first: 500, type: $type, orderBy: $orderBy) {
    data {
      ${FRAGEMENT_POST}
      categories {
        ${FRAGEMENT_POST_CATEGORIES}
      }
      meta {
        ${FRAGEMENT_META}
      }
    }
    paginatorInfo {
      ${FRAGMENT_POST_PAGINATION}
    }
  }
}
`

export const Q_SANDBOX = `
query{
  posts(first: 1, type: SUSTAINABILITY_COMMITMENT) {
    data {
      ${FRAGEMENT_POST}
      categories {
        ${FRAGEMENT_POST_CATEGORIES}
      }
      meta {
        ${FRAGEMENT_META}
      }
    }
    paginatorInfo {
      ${FRAGMENT_POST_PAGINATION}
    }
  }
}
`

export const Q_NEWSROOM = `
query Page($slug: String!, $year: Int) {
  mediaKit: post(slug: $slug) {
     ${FRAGEMENT_POST}
     categories {
      ${FRAGEMENT_POST_CATEGORIES}
    }
      meta {
       ${FRAGEMENT_META}
      }
  }
  gallery: posts(first: 100, type: MEDIA_KIT) {
    data {
      ${FRAGEMENT_POST}
      categories {
        ${FRAGEMENT_POST_CATEGORIES}
      }
      meta {
        ${FRAGEMENT_META}
      }
    }
    paginatorInfo {
      ${FRAGMENT_POST_PAGINATION}
    }
  }
  news: posts(first: 9, type: NEWS, orderBy: [ {column: "published_at", order: DESC} ], page: 1, year: $year) {
    data {
      ${FRAGEMENT_POST}
      categories {
        ${FRAGEMENT_POST_CATEGORIES}
      }
      meta {
        ${FRAGEMENT_META}
      }
    }
    paginatorInfo {
      ${FRAGMENT_POST_PAGINATION}
    }
  }
}
`

export const Q_CAREER_PAGE = `
query careerPage($slug: String!) {
  data: post(slug: $slug) {
    ${FRAGEMENT_POST}
    categories {
     ${FRAGEMENT_POST_CATEGORIES}
    }
    meta {
      ${FRAGEMENT_META}
    }
 }
 lifeAtList: posts(first: 10, type: LIFE_AT_CINEMA) {
    data {
      ${FRAGEMENT_POST}
      categories {
        ${FRAGEMENT_POST_CATEGORIES}
      }
      meta {
        ${FRAGEMENT_META}
      }
    }
  }
  listJobs: jobs(first: 12, page: 1) {
    data {
     ${FRAGMENT_JOB}
    }
    paginatorInfo {
      ${FRAGMENT_POST_PAGINATION}
    }
  }
  listJobLocations: jobLocations {
    id
    name
  }
}
`

export const Q_POSTS_MINIMUM = `
query getListInvestors ($parentId: Int, $first: Int!) {
  posts(parentId: $parentId, first: $first, type: PAGE, orderBy: [{column: "order", order: ASC}]) {
    data {
      id
      slug
      title_id
      title_en
      template
      page_report_category_id
      page_report_show_filter
      page_report_executive_category_id
    }
  }
}
`

export const Q_EXECUTIVE_BY_CATEGORY = `
query executiveByCategories($categoryId: Int!) {
  executive: posts(first: 100, type: EXECUTIVE, categoryId: $categoryId, orderBy: [{column: "order", order: ASC}]) {
    data {
     ${FRAGEMENT_POST}
    }
  }
}
`
